"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var body_scroll_lock_1 = require("body-scroll-lock");
var Icons_1 = require("../Icons");
var faBars_1 = require("@fortawesome/pro-regular-svg-icons/faBars");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styled_components_1 = __importDefault(require("styled-components"));
var SlideMenu = /** @class */ (function (_super) {
    __extends(SlideMenu, _super);
    function SlideMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.shouldComponentUpdate = function (nextProps, nextState) {
            return !(0, react_fast_compare_1.default)(_this.props, nextProps) || !(0, react_fast_compare_1.default)(_this.state, nextState);
        };
        _this.scroller = undefined;
        _this.closeMenu = function () {
            _this.setState({ isOpen: false });
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.openMenu = function () {
            _this.setState({ isOpen: true });
        };
        return _this;
    }
    SlideMenu.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.isOpen && !this.state.isOpen) {
            (0, body_scroll_lock_1.enableBodyScroll)(this.scroller);
        }
        else if (!prevState.isOpen && this.state.isOpen) {
            (0, body_scroll_lock_1.disableBodyScroll)(this.scroller);
        }
    };
    SlideMenu.prototype.componentWillUnmount = function () {
        (0, body_scroll_lock_1.clearAllBodyScrollLocks)();
    };
    SlideMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, closer = _a.closer, closerClassName = _a.closerClassName, footer = _a.footer, header = _a.header, hideCloseButton = _a.hideCloseButton, icon = _a.icon, iconClassName = _a.iconClassName, _b = _a.right, right = _b === void 0 ? false : _b, _c = _a.testid, testid = _c === void 0 ? 'slideMenu' : _c, title = _a.title;
        var isOpen = this.state.isOpen;
        var closeButtonView = (react_1.default.createElement(CloseButton, { className: closerClassName, "data-testid": "slide-menu-closer", onClick: this.closeMenu }, closer ? closer : react_1.default.createElement(Icons_1.CloseIconSmall, { showHover: true })));
        var childView = react_1.default.Children.map(children, function (child) {
            if (!(child === null || child === void 0 ? void 0 : child.props.preventclose)) {
                return react_1.default.createElement(CloseItem, { onClick: _this.closeMenu }, child);
            }
            else {
                return child;
            }
        });
        var slider = (react_1.default.createElement(SlideMenuWrapper, { "$isOpen": isOpen },
            react_1.default.createElement(Overlay, { "$isOpen": isOpen, "$isRight": right, onClick: this.closeMenu }),
            react_1.default.createElement(SlideMenuOuter, { "$isOpen": isOpen, "$isRight": right, className: className, "data-testid": "slide-menu" },
                !hideCloseButton && closeButtonView,
                header,
                react_1.default.createElement(SlideMenuInner, { ref: function (ref) { return (_this.scroller = ref); } },
                    react_1.default.createElement(MenuChildren, null, childView)),
                footer,
                react_1.default.createElement(SlideMenuShadow, { "$isOpen": isOpen }))));
        return (react_1.default.createElement("div", { "data-testid": testid },
            react_1.default.createElement(OpenIcon, { className: iconClassName, "data-testid": "slide-menu-opener", onClick: this.openMenu },
                icon,
                title),
            typeof document !== 'undefined' && react_dom_1.default.createPortal(slider, document.body)));
    };
    SlideMenu.defaultProps = {
        hideCloseButton: false,
        icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBars_1.faBars }),
        right: false,
    };
    return SlideMenu;
}(react_1.default.Component));
exports.default = SlideMenu;
var SlideMenuWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: ", ";\n    z-index: 1000;\n"], ["\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: ", ";\n    z-index: 1000;\n"])), function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? 'auto' : 'none');
});
var Overlay = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    left: 0;\n    opacity: ", ";\n    position: absolute;\n    right: 0;\n    z-index: 1001;\n    bottom: 0;\n    top: 0;\n    transform: ", ";\n    transition: opacity 0.1s ease;\n"], ["\n    background: ", ";\n    left: 0;\n    opacity: ", ";\n    position: absolute;\n    right: 0;\n    z-index: 1001;\n    bottom: 0;\n    top: 0;\n    transform: ", ";\n    transition: opacity 0.1s ease;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.shadowOverlay200;
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? 1 : 0);
}, function (_a) {
    var $isOpen = _a.$isOpen, $isRight = _a.$isRight;
    return $isOpen ? 'none' : $isRight ? 'translate3d(-100%, 0, 0)' : 'translate3d(100%, 0, 0)';
});
var SlideMenuOuter = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n    background-color: ", ";\n    max-width: 75%;\n    right: inherit;\n    transform: ", ";\n    transform-origin: left center;\n    transition: transform 0.25s ease-in-out 0s;\n    width: 300px;\n    z-index: 1002;\n"], ["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n    background-color: ", ";\n    max-width: 75%;\n    right: inherit;\n    transform: ", ";\n    transform-origin: left center;\n    transition: transform 0.25s ease-in-out 0s;\n    width: 300px;\n    z-index: 1002;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var $isOpen = _a.$isOpen, $isRight = _a.$isRight;
    if ($isOpen && $isRight) {
        return 'translate3d(calc(100vw - 100%), 0, 0)';
    }
    else if ($isOpen) {
        return 'translate3d(0, 0, 0)';
    }
    else if ($isRight) {
        return 'translate3d(100vw, 0, 0)';
    }
    return 'translate3d(-100%, 0, 0)';
});
var SlideMenuInner = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex: 1;\n    overflow-y: auto;\n"], ["\n    flex: 1;\n    overflow-y: auto;\n"])));
var MenuChildren = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex-direction: column;\n"])));
var SlideMenuShadow = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    bottom: 0;\n    box-shadow: ", " 0 0 15px 0;\n    height: 100%;\n    left: 0;\n    opacity: ", ";\n    position: absolute;\n    right: 0;\n    top: 0;\n    transition: opacity 0.3s ease 0s;\n    width: 100%;\n    z-index: -1;\n"], ["\n    bottom: 0;\n    box-shadow: ", " 0 0 15px 0;\n    height: 100%;\n    left: 0;\n    opacity: ", ";\n    position: absolute;\n    right: 0;\n    top: 0;\n    transition: opacity 0.3s ease 0s;\n    width: 100%;\n    z-index: -1;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.shadowOverlay200;
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? 1 : 0);
});
var CloseButton = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    right: 21px;\n    top: 18px;\n"], ["\n    position: absolute;\n    right: 21px;\n    top: 18px;\n"])));
var CloseItem = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: 0;\n"], ["\n    padding: 0;\n"])));
var OpenIcon = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: 24px;\n    color: ", ";\n"], ["\n    font-size: 24px;\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey100;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
